import { j as a } from "../../../../node_modules/react/jsx-runtime.js";
import { memo as Mt, useState as y, useMemo as p, useRef as Et, useCallback as v, useEffect as Bt } from "react";
import { useReactTable as $t, flexRender as dt } from "../../../../node_modules/@tanstack/react-table/build/lib/index.js";
import { i18n as Ot } from "../../../../utils/locale/locale.js";
import { clsx as Vt } from "../../../../node_modules/clsx/dist/clsx.m.js";
import J from "../../../../node_modules/lodash/isEmpty.js";
import _t from "../../../../node_modules/lodash/isNumber.js";
import Q from "../../../../node_modules/lodash/isString.js";
import qt from "../../../../node_modules/lodash/merge.js";
import { Typography as Gt } from "../../../atoms/Typography/Typography.js";
import Kt from "../../../atoms/ScrollbarContainer/ScrollBarContainer.js";
import Wt from "../../AvatarLabel/AvatarLabel.js";
import { getDefaultSelectedRows as U, getTableColumns as Xt, getFlattedColumns as Jt } from "../helper.js";
import b from "../Table.module.scss.js";
import { getCoreRowModel as Qt } from "../../../../node_modules/@tanstack/table-core/build/lib/index.js";
import ut from "./DataRow/DataRow.js";
import Ut from "./HeaderCell/HeaderCell.js";
import Yt from "./DataCell/DataCell.js";
import Zt from "./TableControls/TableControls.js";
import Tt from "./TableSegmentedControl/TableSegmentedControl.js";
import zt from "./TableLoader/TableLoader.js";
import te from "./TablePagination/TablePagination.js";
import ee from "../../AvatarGroup/AvatarGroup.js";
import ne from "./TableActions/TableActions.js";
const se = (mt) => {
  var ct;
  const {
    columns: I,
    data: Y,
    headerControls: i,
    headerAdditionalControls: gt,
    segmentedControl: Z,
    pagination: T,
    rowDensity: A = "auto",
    tableSize: c,
    pageSize: L = 0,
    pinColums: R,
    loading: z,
    selectable: h,
    options: e,
    testId: ft,
    onRowSelected: tt,
    onRowClick: V,
    onScrollEnd: _,
    onSort: C,
    noDataPlaceholder: ht
  } = mt, [x, et] = y(!1), [M, nt] = y([]), [xt, wt] = y(A), [j, yt] = y({ key: "", direction: "asc" }), pt = p(
    () => U((e == null ? void 0 : e.defaultSelectedRows) ?? []) ?? {},
    [e == null ? void 0 : e.defaultSelectedRows]
  ), [S, Rt] = y(pt), [q, jt] = y(), [F, st] = y(I), D = i != null && i.onDensityChange ? xt : A, G = Et(null), K = p(
    () => Xt(F, M, e, h),
    [h, M, e, F]
  ), it = (t) => {
    var n, s, l;
    return !((s = (n = e == null ? void 0 : e.enableRowSelection) == null ? void 0 : n.call(e, t)) != null && s.disabled) && !((l = e == null ? void 0 : e.isDisabledRow) != null && l.call(e, t));
  }, Dt = (t) => Object.keys(t).map((s) => {
    var l;
    try {
      const o = rt.getRow(s);
      if (o) {
        const d = (l = e == null ? void 0 : e.getRowId) == null ? void 0 : l.call(e, o.original);
        return {
          ...o.original,
          ...d && { id: d }
        };
      }
      return null;
    } catch {
      return null;
    }
  }).filter(Boolean), Ht = (t) => {
    const n = e != null && e.selectedRows ? t(U(e == null ? void 0 : e.selectedRows)) : t(S);
    if (Rt(n), tt) {
      const s = Dt(n), o = Object.keys(n).filter(
        (f) => !s.find((m) => (m == null ? void 0 : m.id) === f)
      ).map((f) => q == null ? void 0 : q.find((m) => m.id === f)).filter(Boolean), d = [...s, ...o];
      jt(d), tt(d);
    }
  }, vt = v(
    (t, n) => {
      yt({ key: t, direction: n }), C == null || C(t, n);
    },
    [C]
  ), rt = $t(
    qt({
      columns: K,
      data: Y,
      getCoreRowModel: Qt(),
      state: {
        sorting: [{ id: j.key, desc: j.direction === "desc" }],
        rowSelection: e != null && e.selectedRows ? U(e == null ? void 0 : e.selectedRows) : S
      },
      onSortingChange: (t) => vt(t[0].id, t[0].desc ? "desc" : "asc"),
      onRowSelectionChange: Ht,
      getRowId: (t) => {
        var n;
        return ((n = e == null ? void 0 : e.getRowId) == null ? void 0 : n.call(e, t)) ?? t.id;
      },
      enableRowSelection: (t) => it(t.original),
      getRowCanSelect: (t) => it(t.original),
      options: e
    })
  ), { getHeaderGroups: E, getRowModel: bt, setSorting: Ct } = rt, { rows: w } = bt(), g = p(
    () => {
      var t, n;
      return (n = (t = E()) == null ? void 0 : t.some) == null ? void 0 : n.call(
        t,
        (s) => {
          var l;
          return (l = s.headers) == null ? void 0 : l.some((o) => {
            var d;
            return ((d = o.subHeaders) == null ? void 0 : d.length) > 0;
          });
        }
      );
    },
    [E, F]
  ), B = (t) => {
    const n = w.length > L ? L : w.length;
    return t * n + (g ? 80 : 40);
  }, St = {
    auto: B(60.5),
    relaxed: B(60.5),
    regular: B(48.5),
    condensed: B(40.5)
  }, r = p(() => {
    const t = !w.length && !(c != null && c.height) ? "400px" : c == null ? void 0 : c.height;
    return {
      width: (c == null ? void 0 : c.width) ?? "100%",
      height: (L ? St[D] : t) ?? "auto",
      minHeight: (c == null ? void 0 : c.minHeight) ?? (g ? 100 : 60),
      maxHeight: (c == null ? void 0 : c.maxHeight) ?? "auto"
    };
  }, [
    c == null ? void 0 : c.width,
    c == null ? void 0 : c.height,
    c == null ? void 0 : c.minHeight,
    c == null ? void 0 : c.maxHeight,
    D,
    g,
    L,
    w.length
  ]), Ft = v(() => {
    var n, s, l, o, d, f, m, H, u, P, k, N;
    const t = G.current;
    x && document.fullscreenEnabled && document.fullscreenElement ? ((s = (n = t == null ? void 0 : t.classList) == null ? void 0 : n.remove) == null || s.call(n, b.fullScreen), (o = (l = t == null ? void 0 : t.style) == null ? void 0 : l.setProperty) == null || o.call(l, "width", `${r == null ? void 0 : r.width}`, "important"), (f = (d = t == null ? void 0 : t.style) == null ? void 0 : d.setProperty) == null || f.call(d, "hight", `${r == null ? void 0 : r.height}`, "important"), (H = (m = t == null ? void 0 : t.style) == null ? void 0 : m.setProperty) == null || H.call(m, "minHeight", `${r == null ? void 0 : r.minHeight}`, "important"), (P = (u = t == null ? void 0 : t.style) == null ? void 0 : u.setProperty) == null || P.call(u, "maxHeight", `${r == null ? void 0 : r.maxHeight}`, "important"), (k = document == null ? void 0 : document.exitFullscreen) == null || k.call(document), et(!1)) : t != null && t.requestFullscreen && (t.className = b.fullScreen, t.style.setProperty("width", "100%", "important"), t.style.setProperty("hight", "100%", "important"), t.requestFullscreen(), et(!0)), typeof (i == null ? void 0 : i.onFullScreenClick) == "function" && ((N = i == null ? void 0 : i.onFullScreenClick) == null || N.call(i));
  }, [i, x, r]), Pt = v(
    (t) => {
      var n;
      wt(t), typeof (i == null ? void 0 : i.onDensityChange) == "function" && ((n = i == null ? void 0 : i.onDensityChange) == null || n.call(i, t));
    },
    [i]
  ), kt = v((t, n) => {
    nt((s) => n ? s.filter((l) => l !== t) : [...s, t]);
  }, []), Nt = v(
    (t) => {
      var n;
      g || (st(t), typeof (i == null ? void 0 : i.onColumnSort) == "function" && ((n = i == null ? void 0 : i.onColumnSort) == null || n.call(i, t)));
    },
    [i, g]
  ), ot = v(
    (t, n) => {
      const s = t.target;
      s.closest("td") && !s.closest("input") && !s.closest("button") && V && V(t, n);
    },
    [V]
  ), It = p(
    () => /* @__PURE__ */ a.jsx(a.Fragment, { children: E().map((t) => /* @__PURE__ */ a.jsx(ut, { children: t.headers.map((n, s) => {
      var d, f;
      const l = ((d = n.subHeaders) == null ? void 0 : d.length) > 0, o = n.column.columnDef.alignment;
      return /* @__PURE__ */ a.jsx(
        Ut,
        {
          id: n.id,
          colSpan: n.colSpan,
          type: l ? "header-group" : "header-cell",
          alignment: o,
          ...((f = e == null ? void 0 : e.sortableColumns) == null ? void 0 : f.includes(n.column.id ?? "")) && {
            onSort: (m) => {
              Ct([{ id: n.id, desc: m === "desc" }]);
            },
            sortDir: j == null ? void 0 : j.direction
          },
          text: Q(n.column.columnDef.header) ? n.column.columnDef.header : "",
          custom: !Q(n.column.columnDef.header) && dt(n.column.columnDef.header, n.getContext()),
          pinnedFirst: ["first", "both"].includes(R ?? "") && [h ? 1 : 0].includes(s),
          pinnedLast: ["last", "both"].includes(R ?? "") && s === t.headers.length - 1,
          width: n.column.columnDef.width,
          selectable: !!h
        },
        n.id
      );
    }) }, t.id)) }),
    [
      E,
      R,
      j,
      C,
      e == null ? void 0 : e.sortableColumns,
      e == null ? void 0 : e.enableRowSelection,
      h,
      S,
      K
    ]
  ), At = p(
    () => /* @__PURE__ */ a.jsx(a.Fragment, { children: w.map((t) => {
      const n = e != null && e.isDisabledRow ? e.isDisabledRow(t.original) : !1;
      return /* @__PURE__ */ a.jsx(
        ut,
        {
          ...!n && {
            onClick: (s) => ot(s, t),
            active: t.getIsSelected()
          },
          ...n && { disabled: n },
          children: t.getVisibleCells().map((s, l) => {
            var m;
            const o = (m = s == null ? void 0 : s.column) == null ? void 0 : m.columnDef, d = (typeof (o == null ? void 0 : o.actions) == "function" ? o == null ? void 0 : o.actions(t.original) : o == null ? void 0 : o.actions) ?? [], f = () => {
              var k, N, at;
              const H = s.renderValue(), u = (k = o.leadingCell) == null ? void 0 : k.call(o, t.original);
              if (!J(u)) {
                const W = (u == null ? void 0 : u.text) ?? "", X = (u == null ? void 0 : u.sub_text) ?? "", $ = (u == null ? void 0 : u.avatar) ?? "", O = (u == null ? void 0 : u.initial_avatar) ?? "", lt = (u == null ? void 0 : u.onClick) ?? "";
                return $ || O ? {
                  custom: /* @__PURE__ */ a.jsx(
                    Wt,
                    {
                      ...lt && { onClick: lt },
                      ...W && { headerText: W },
                      ...D !== "condensed" && X && { supportingText: X },
                      ...$ && { avatarLogo: $ },
                      avatarProps: {
                        ...O && { type: "initials", imageAlt: O }
                      },
                      size: A === "condensed" ? "compact" : "expanded",
                      showDropdown: !1,
                      type: $ || O ? "default" : "subtil",
                      className: "!p-0 !m-0 h-full w-fit"
                    }
                  )
                } : { text: W, subText: X };
              }
              const P = ((N = o.avatars) == null ? void 0 : N.call(o, t.original)) ?? [];
              return J(P) ? J(d) ? Q(H) || _t(H) ? {
                text: String(H)
              } : {
                custom: dt(o == null ? void 0 : o.cell, (at = s == null ? void 0 : s.getContext) == null ? void 0 : at.call(s))
              } : {
                custom: /* @__PURE__ */ a.jsx("div", { className: "flex justify-center items-center h-full w-full", children: /* @__PURE__ */ a.jsx(
                  ne,
                  {
                    actions: d,
                    data: t.original
                  }
                ) }),
                actions: d
              } : {
                custom: /* @__PURE__ */ a.jsx("div", { className: "flex justify-center items-center h-full w-full", children: /* @__PURE__ */ a.jsx(
                  ee,
                  {
                    avatars: P,
                    size: "m"
                  }
                ) })
              };
            };
            return /* @__PURE__ */ a.jsx(
              Yt,
              {
                id: s == null ? void 0 : s.id,
                ...o,
                ...f(),
                actions: d,
                disabled: n,
                pinnedFirst: ["first", "both"].includes(R ?? "") && [h ? 1 : 0].includes(l),
                pinnedLast: ["last", "both"].includes(R ?? "") && l === t.getVisibleCells().length - 1,
                rowMinHeight: A === "auto" && c && "rowMinHeight" in c ? c.rowMinHeight : "auto",
                rowDensity: D,
                selectable: !!h,
                isSelected: t.getIsSelected()
              },
              s == null ? void 0 : s.id
            );
          })
        },
        t.id
      );
    }) }),
    [
      w,
      ot,
      R,
      D,
      h,
      S,
      K,
      e == null ? void 0 : e.sortableColumns,
      e == null ? void 0 : e.enableRowSelection,
      e == null ? void 0 : e.isDisabledRow,
      Y
    ]
  ), Lt = p(
    () => Jt(g, F, M),
    [F, M, g]
  );
  return Bt(() => {
    var t, n, s;
    I.length && st(I), (s = (n = (t = G.current) == null ? void 0 : t.style) == null ? void 0 : n.setProperty) == null || s.call(
      n,
      "--head-before-height",
      g ? "56px" : "46px"
    ), nt([]);
  }, [g, I]), /* @__PURE__ */ a.jsxs(
    "div",
    {
      "data-testid": "table-container",
      ref: G,
      ...(r == null ? void 0 : r.width) && !x && {
        style: {
          overflowX: "scroll",
          width: r == null ? void 0 : r.width
        }
      },
      className: "pt-025",
      children: [
        i && /* @__PURE__ */ a.jsx(
          Zt,
          {
            ...i,
            ...i.onFullScreenClick && { onFullScreenClick: Ft },
            ...i.onDensityChange && {
              onDensityChange: Pt,
              selectedDensity: D
            },
            ...i.onColumnSort && {
              onColumnDisplay: kt,
              onColumnSort: Nt,
              columns: Lt.filter(
                (t) => t !== void 0
              ),
              sortable: !g
            },
            ...i.total && { total: i.total },
            isFullScreen: x,
            selected: e != null && e.selectedRows ? (ct = e == null ? void 0 : e.selectedRows) == null ? void 0 : ct.length : Object.keys(S).length,
            headerAdditionalControls: gt
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: b.table,
            ...!x && {
              style: {
                width: r == null ? void 0 : r.width
              }
            },
            children: [
              Z && /* @__PURE__ */ a.jsx(Tt, { ...Z }),
              /* @__PURE__ */ a.jsxs("div", { className: "relative", children: [
                z && /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: Vt(b.tableLoader, g ? "top-[78px]" : "top-[38px]"),
                    children: /* @__PURE__ */ a.jsx(zt, { loading: !0 })
                  }
                ),
                !z && !w.length && /* @__PURE__ */ a.jsx("div", { className: b.emptyContainer, children: ht || /* @__PURE__ */ a.jsx(
                  Gt,
                  {
                    text: Ot("no_results_found"),
                    variant: "interface/default/sm",
                    textColor: "color/fg/lighter"
                  }
                ) }),
                /* @__PURE__ */ a.jsx(
                  Kt,
                  {
                    handleScrollEnd: () => _ == null ? void 0 : _(),
                    height: x ? "100%" : r == null ? void 0 : r.height,
                    minHeight: x ? "100%" : r == null ? void 0 : r.minHeight,
                    maxHeight: x ? "calc(100vh - 207px)" : r == null ? void 0 : r.maxHeight,
                    width: r == null ? void 0 : r.width,
                    className: "bg-color-bg-neutral-lightest-default",
                    children: /* @__PURE__ */ a.jsxs("table", { "data-testid": ft, children: [
                      /* @__PURE__ */ a.jsx("thead", { children: It }),
                      /* @__PURE__ */ a.jsx("tbody", { children: w.length > 0 && At })
                    ] })
                  }
                )
              ] })
            ]
          }
        ),
        T && /* @__PURE__ */ a.jsx("div", { className: b.paginationContainer, children: /* @__PURE__ */ a.jsx(te, { ...T }) })
      ]
    }
  );
}, Fe = Mt(se);
export {
  Fe as default
};
//# sourceMappingURL=BasicTable.js.map
